<template>
    <div>
        <users-management></users-management>
    </div>
</template>

<script>
import usersManagement from 'fundation-app-vuejs/src/components/usersManagement/user';
export default {

    components:{
        usersManagement,
    },

    name: 'index',

    data () {
        return {

        };
    }
};
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/Users/index.vue